export default "__VITE_ASSET__5u5IzUNX__"